import { BaseControl } from '..';
import { ColorControl } from '../ColorControl';
import { NumberControl } from '../NumberControl';
import { SelectControl } from '../SelectControl';

/**
 * @typedef {object} BorderControlOptions
 */

/**
 * @typedef {object} BorderControlValue
 * @property {string} borderColor - Border color (e.g. '#ff0000')
 * @property {number} borderWidth - Border width in pixels (e.g. 1)
 * @property {string} borderStyle - Border style (e.g. 'solid', 'dashed', 'dotted')
 * @property {number} borderRadius - Border radius in pixels (e.g. 5)
 */

/**
 * @extends BaseControl<BorderControlValue, BorderControlOptions>
 */
export class BorderControl extends BaseControl {

    /**
     * @param {import('..').BaseControlDefinition<BorderControlValue, BorderControlOptions>} control 
     */
    constructor(control) {
        super(control);

        this.children = {
            borderColor: new ColorControl({
                label: 'Kleur',
                defaultValue: '#000000',
                options: {
                    useHousestyles: true
                }
            }),
            borderWidth: new NumberControl({
                label: 'Dikte',
                defaultValue: 1,
                options: {
                    min: 0,
                    max: 20,
                    step: 1
                }
            }),
            borderStyle: new SelectControl({
                label: 'Stijl',
                defaultValue: 'solid',
                options: {
                    choices: [
                        { value: 'none', label: 'Geen' },
                        { value: 'solid', label: 'Solide' },
                        { value: 'dashed', label: 'Gestreept' },
                        { value: 'dotted', label: 'Gepunt' },
                        { value: 'double', label: 'Dubbel' },
                        { value: 'groove', label: 'Groef' },
                        { value: 'ridge', label: 'Ribbel' },
                        { value: 'inset', label: 'Ingesloten' },
                        { value: 'outset', label: 'Uitgesloten' },
                        // { value: 'hidden', label: 'Verborgen' }
                    ]
                }
            }),
            borderRadius: new NumberControl({
                label: 'Radius',
                defaultValue: 0,
                options: {
                    min: 0,
                    max: 100,
                    step: 1
                }
            })
        };
    }

    // render(value = {}, onChange) {
    //     return (
    //         <div>
    //             <h3>Rand</h3>
    //             {super.render(value, onChange)}
    //         </div>
    //     );
    // }
}
